import type { GcmConsent } from "../analytics/customEvents.ts";

const UC_GCM_STORAGE_KEY = "uc_gcm";

export function readStoredGcmConsent(): GcmConsent | null {
  try {
    const raw = localStorage.getItem(UC_GCM_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as GcmConsent) : null;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(): boolean {
  return readStoredGcmConsent()?.analyticsStorage === "granted";
}
